import { render } from "./SnackBar.vue?vue&type=template&id=813ae698&ts=true"
import script from "./SnackBar.vue?vue&type=script&lang=ts"
export * from "./SnackBar.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__